/**
 * Appends ?noindex=1 to an image URL to prevent search engine indexing.
 * Used for category page tile images that should not appear in search results.
 */
export const appendNoIndexParam = (url: string): string => {
    if (!url) {
        return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}noindex=1`;
};
